import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDocumentExtraction } from "../context/DocumentExtractionContext";
import { buildExtractionJobUrl } from "../utils/documentExtractionNavigation";
import { isOnJobContextPage } from "../utils/documentExtractionReviewOpen";

/** Navigates to the upload context when extraction is ready for review on another page. */
export default function ExtractionReviewAutoOpen() {
  const { reviewReadyJob, consumeReviewReadyJob } = useDocumentExtraction();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!reviewReadyJob) return;

    // const job = reviewReadyJob;
    // if (!isOnJobContextPage(location.pathname, location.search, job)) {
    //   navigate(buildExtractionJobUrl(job, true));
    // }
    consumeReviewReadyJob();
  }, [reviewReadyJob, consumeReviewReadyJob]);

  return null;
}
